<template>
  <section class="out-layout">
    <!-- <portal-brand /> -->

    <div class="content">
      <img class="ima-logo"
        src="@/assets/image/authentication/ima-logo-green.svg"
        alt="Logo IMA Alagoas">

      <v-card class="elevation-10 card-form">
        <slot name="form-header" />
        <slot name="form-content" />
      </v-card>

      <nav class="navigation">
        <slot name="navigation" />
      </nav>
    </div>
  </section>
</template>

<script>

  export default {
  name: 'OutLayout',
  components: {},
};
</script>

<style lang="scss">
.out-layout {
  & {
    display: grid;
    // justify-items: center;
    // align-content: space-evenly;
    height: 100vh;
  }

  > .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .ima-logo {
    margin-bottom: 2rem;
    max-width: 80px;
  }

  .card-form {
    padding: 2rem 2rem 1rem;
    width: 400px;

    .header {
      text-align: center;
    }

    .action {
      justify-content: space-around;
    }
  }

  .navigation {
    & {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem;
    }

    >.link {
      text-transform: none;
    }
  }
}
</style>
